import { InboxMessage } from "@pages/inbox/InboxMessage";
import { $staffApi } from "../../../api";
import { Thread } from "../types";

export function UserNotes({ thread }: { thread: Thread }) {
  const { data: notes } = $staffApi.useSuspenseQuery("get", "/api/user_notes/", {
    params: {
      query: {
        user: thread.user.id,
        ordering: ["-updated_at"],
      },
    },
  });

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "var(--space-m)" }}>
      <div>
        {notes.results.length
          ? notes.results.map((note) => (
              <InboxMessage
                id={note.id}
                key={note.id}
                onClick={() => window.open(`/users/${thread.user.id}/notes`, "_blank")}
                name={note.author.full_name}
                message={note.body}
                time={note.updated_at}
              />
            ))
          : "No notes for this user."}
      </div>
    </div>
  );
}
